module.exports = __webpack_public_path__ + "img/label.f7c0916e.svg";